module.exports = __webpack_public_path__ + "static/media/PD_logo_Teal.37e9d7db.png";